import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/EnvironmentalLabsLogoHorizontal.png";
import landingPageImage1 from "../../images/landing-page-1.jpeg";
import landingPageImage2 from "../../images/landing-page-2.jpeg";
import landingPageImage3 from "../../images/landing-page-3.jpeg";
import landingPageImage4 from "../../images/landing-page-4.jpeg";
import { AuthenticateUser } from "../../services/usersService";
import { NotificationManager } from "react-notifications";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEye,
  faEyeSlash,
  faEnvelope,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import CommonLoader from "../../vlp/components/common/CommonLoader";
import ResetPassword from "./ResetPassword";
import TakeResetPassword from "./TakeResetPassword";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [tempToken, setTempToken] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [isTakeResetPassword, setIsTakeResetPassword] = useState(false);
  const [isLoginScreen, setIssLoginScreen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const backgroundImages = [
    landingPageImage1,
    landingPageImage2,
    landingPageImage3,
    landingPageImage4
  ];

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("/reset-password")) {
      setIssLoginScreen(false);
      setIsTakeResetPassword(true);
      // Extract the token from the URL
      const parts = path.split("/");
      const tokenIndex = parts.indexOf("reset-password") + 1;
      if (tokenIndex < parts.length) {
        const token = parts[tokenIndex];
        setTempToken(token);
      }
    }
  }, []);

  // Image slideshow effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % backgroundImages.length
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  const handleLogin = () => {
    if (!username || !password) {
      NotificationManager.error("Username/Email and Password are required");
    } else {
      try {
        AuthenticateUserFromService();
      } catch (error) {
        NotificationManager.error("Invalid username/email or password.");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  const handleResetPassword = () => {
    setIsResetPassword(true);
    setIssLoginScreen(false);
  };

  const handleTogglePassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  async function AuthenticateUserFromService() {
    try {
      setLoading(true);
      let response = await AuthenticateUser(username, password);
      NotificationManager.success("Logged in successfully.");
      window.location.reload();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      NotificationManager.error("Invalid username/email or password.");
    }
  }

  return (
    <>
      {isLoginScreen && (
        <section className="hero is-fullheight" style={{ padding: 0 }}>
          <div style={{ display: "flex", height: "100vh" }}>
            {/* Left side - Background Image with Gradient (2/3 width) - Hidden on mobile */}
            <div
              className="is-hidden-mobile"
              style={{
                flex: "2",
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                overflow: "hidden",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
              }}
            >
              {/* Background Images */}
              {backgroundImages.map((image, index) => (
                <div
                  key={index}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: `
                      linear-gradient(135deg, rgba(0, 125, 209, 0.85) 0%, rgba(75, 164, 223, 0.75) 50%, rgba(0, 125, 209, 0.9) 100%),
                      url(${image})
                    `,
                    backgroundSize: "110%",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    animation: "backgroundZoom 20s ease-in-out infinite",
                    opacity: currentImageIndex === index ? 1 : 0,
                    transition: "opacity 1.5s ease-in-out",
                    zIndex: currentImageIndex === index ? 2 : 1,
                  }}
                />
              ))}
              {/* Content overlay for the background section */}
              <div
                style={{
                  textAlign: "center",
                  color: "white",
                  maxWidth: "500px",
                  padding: "2rem",
                  position: "relative",
                  zIndex: 10,
                }}
              >
                <h1
                  style={{
                    fontSize: "3rem",
                    fontWeight: "500",
                    marginBottom: "1.5rem",
                    textShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
                    lineHeight: "1.2",
                  }}
                >
                  Welcome to Extend
                </h1>
                <p
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "300",
                    lineHeight: "1.6",
                    textShadow: "0 1px 5px rgba(0, 0, 0, 0.3)",
                    opacity: "0.95",
                  }}
                >
                  Your ally in the world of environmental testing and compliance
                </p>
              </div>

              {/* Image indicators */}
              <div
                style={{
                  position: "absolute",
                  bottom: "2rem",
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: "0.5rem",
                  zIndex: 10,
                }}
              >
                {backgroundImages.map((_, index) => (
                  <div
                    key={index}
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      background: currentImageIndex === index 
                        ? "rgba(255, 255, 255, 0.9)" 
                        : "rgba(255, 255, 255, 0.4)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                ))}
              </div>
            </div>

            {/* Right side - Login Form (1/3 width) */}
            <div
              style={{
                flex: "1",
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2rem",
                minHeight: "100vh",
                borderTopLeftRadius: "50px",
                borderBottomLeftRadius: "50px",
              }}
              className="is-flex-direction-column"
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: "400px",
                }}
              >
                <div
                  className="box"
                  style={{
                    background: "rgba(255, 255, 255, 0.95)",
                    backdropFilter: "blur(20px)",
                    borderRadius: "20px",
                    padding: "3rem 2.5rem",
                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    animation: "fadeInUp 0.8s ease-out 0.2s both",
                  }}
                >
                  {/* Logo Section */}
                  <div className="has-text-centered mb-5">
                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                        borderRadius: "25px",
                        padding: "1rem",
                        display: "inline-block",
                        marginBottom: "1rem",
                      }}
                    >
                      <a href="/">
                        <img
                          src={logo}
                          alt="ELI Logo"
                          style={{
                            maxHeight: "60px",
                            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))",
                          }}
                        />
                      </a>
                    </div>
                    <p
                      className="subtitle is-6 has-text-grey"
                      style={{
                        marginBottom: "2rem",
                      }}
                    >
                      Access your account
                    </p>
                  </div>

                  {/* Username Field */}
                  <div className="field">
                    <label
                      className="label has-text-grey-dark"
                      style={{
                        fontSize: "0.9rem",
                        fontWeight: "600",
                      }}
                    >
                      Username or Email
                    </label>
                    <div className="control has-icons-left">
                      <input
                        className="input is-medium"
                        type="text"
                        placeholder="Enter your username or email"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyPress={handleKeyPress}
                        style={{
                          borderRadius: "20px",
                          border: "2px solid #e1e5e9",
                          transition: "all 0.3s ease",
                          fontSize: "1rem",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#007DD1";
                          e.target.style.boxShadow =
                            "0 0 0 3px rgba(0, 125, 209, 0.1)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e1e5e9";
                          e.target.style.boxShadow = "none";
                        }}
                      />
                      <span className="icon is-small is-left has-text-grey">
                        <FontAwesomeIcon icon={faUser} />
                      </span>
                    </div>
                  </div>

                  {/* Password Field */}
                  <div className="field">
                    <label
                      className="label has-text-grey-dark"
                      style={{
                        fontSize: "0.9rem",
                        fontWeight: "600",
                      }}
                    >
                      Password
                    </label>
                    <div className="field has-addons">
                      <div className="control is-expanded has-icons-left">
                        <input
                          className="input is-medium"
                          placeholder="Enter your password"
                          type={passwordVisible ? "text" : "password"}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          onKeyPress={handleKeyPress}
                          style={{
                            borderRadius: "20px 0 0 20px",
                            border: "2px solid #e1e5e9",
                            borderRight: "1px solid #e1e5e9",
                            transition: "all 0.3s ease",
                            fontSize: "1rem",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#007DD1";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(0, 125, 209, 0.1)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e1e5e9";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                        <span className="icon is-small is-left has-text-grey">
                          <FontAwesomeIcon icon={faLock} />
                        </span>
                      </div>
                      <div className="control">
                        <button
                          type="button"
                          className="button is-small"
                          onClick={handleTogglePassword}
                          style={{
                            borderRadius: "0 20px 20px 0",
                            border: "2px solid #e1e5e9",
                            borderLeft: "1px solid #e1e5e9",
                            background: "#f8f9fa",
                            transition: "all 0.3s ease",
                            height: "40px",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.background = "#e9ecef";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.background = "#f8f9fa";
                          }}
                        >
                          <span className="icon is-small has-text-grey">
                            <FontAwesomeIcon
                              icon={passwordVisible ? faEyeSlash : faEye}
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Login Button */}
                  <div className="field" style={{ marginTop: "2rem" }}>
                    <button
                      className="button is-medium is-fullwidth"
                      onClick={handleLogin}
                      style={{
                        background:
                          "linear-gradient(135deg, #007DD1 0%, #4BA4DF 100%)",
                        border: "none",
                        borderRadius: "20px",
                        color: "white",
                        fontWeight: "600",
                        height: "3rem",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 15px rgba(0, 125, 209, 0.4)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                          "0 6px 20px rgba(0, 125, 209, 0.6)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                          "0 4px 15px rgba(0, 125, 209, 0.4)";
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faUser}
                        style={{ marginRight: "0.5rem" }}
                      />
                      <span>Sign In</span>
                    </button>
                  </div>

                  {/* Forgot Password Section */}
                  <div
                    style={{
                      marginTop: "2rem",
                      padding: "1.5rem",
                      background:
                        "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                      borderRadius: "20px",
                      textAlign: "center",
                    }}
                  >
                    <p
                      className="has-text-grey-dark"
                      style={{
                        marginBottom: "1rem",
                        fontSize: "0.9rem",
                      }}
                    >
                      Forgotten your password?
                    </p>
                    <button
                      className="button is-warning is-rounded"
                      onClick={handleResetPassword}
                      style={{
                        fontWeight: "600",
                        transition: "all 0.3s ease",
                        boxShadow: "0 2px 8px rgba(255, 193, 7, 0.3)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-1px)";
                        e.target.style.boxShadow =
                          "0 4px 12px rgba(255, 193, 7, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                          "0 2px 8px rgba(255, 193, 7, 0.3)";
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faLock}
                        style={{ marginRight: "0.5rem" }}
                      />
                      <span>Reset Password</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {isResetPassword && <ResetPassword />}
      {isTakeResetPassword && <TakeResetPassword tempToken={tempToken} />}
      <CommonLoader loading={loading} />

      {/* Add custom CSS for animations */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes backgroundZoom {
            0% {
              background-size: 110%;
              background-position: center center;
            }
            50% {
              background-size: 120%;
              background-position: center 20%;
            }
            100% {
              background-size: 110%;
              background-position: center center;
            }
          }

          @media (max-width: 768px) {
            .hero > div {
              flex-direction: column !important;
            }
            .hero > div > div:first-child {
              display: none !important;
            }
            .hero > div > div:last-child {
              flex: 1 !important;
              min-height: 100vh !important;
              background: linear-gradient(135deg, #007DD1 0%, #4BA4DF 100%) !important;
              border-radius: 0 !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default Login;